import { createAction } from 'redux-actions';

const types = {
  REQUEST_SEARCH_MEMBER_ID: 'REQUEST_SEARCH_MEMBER_ID',
  REQUEST_SEARCH_MEMBER_ID_COMPLETED: 'REQUEST_SEARCH_MEMBER_ID_COMPLETED',
  REQUEST_SEARCH_MEMBER_ID_FAILED: 'REQUEST_SEARCH_MEMBER_ID_FAILED',
  CLEAR_FAILED_DATA: 'CLEAR_FAILED_DATA',
  CLEAR_MEMBER_ID: 'CLEAR_MEMBER_ID',
};

const actionCreators = {
  requestSearch: createAction(types.REQUEST_SEARCH_MEMBER_ID),
  requestSearchCompleted: createAction(
    types.REQUEST_SEARCH_MEMBER_ID_COMPLETED
  ),
  requestSearchFailed: createAction(types.REQUEST_SEARCH_MEMBER_ID_FAILED),
  clearMemberId: createAction(types.CLEAR_MEMBER_ID),
  clearFailedData: createAction(types.CLEAR_FAILED_DATA),
};

export { types, actionCreators };
